// @flow

import { TrackingProviderValues } from '@chatchamp/chatchamp-types'

import type { EventPayload } from '../../common/iframeMessageTypes'

import { forwardEventToGa } from './ga/ga'
import { forwardEventToTealium } from './listeners'

// @deprecated; this should be replaced using the dispatchEvent API
// This is directly called by the iframe event handler.
// That's why it's separate from the other functions
export function forwardEventToWebAnalytics (payload: EventPayload) {
  const { config } = window.chatchamp

  // TODO; Thiago; 17.03.2023; temporary checker to make embedded wizard works without tracking
  if (!config) return

  if (config.tracking?.trackingProvider === TrackingProviderValues.GA) {
    forwardEventToGa(payload)
  } else if (config.tracking?.trackingProvider === TrackingProviderValues.Tealium) {
    forwardEventToTealium(payload)
  } else {
    // Dominik; 23.11.2022; to ensure backwards-compatibility if the tracking provider is not set we still call GA
    forwardEventToGa(payload)
  }
}
